import React, { useState, useEffect, useCallback } from "react";
import { Eye, EyeFill, Printer } from "react-bootstrap-icons";
import { url, headers } from "../../utils/const";
import { ToPrinter } from "../../utils/print-service";
import {
  lotteryTicketLine,
  ticketFromResponse,
  ticketPointName,
  ticketRunCode,
} from "../../utils/lottery-ticket";
import "./ticket.css";
import Modal from "react-bootstrap/Modal";
import imgLogo from "../../assets/logo-reina.png";
import jsPDF from "jspdf";
import "jspdf-autotable";

function Tickets(list) {
  const [show, setShow] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [ticketToPrint, setTicketToPrin] = useState();
  const [ticketStatus, setTicketStatus] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [classPrint, setClassPrint] = useState("noDisplay");
  useEffect(() => {
    setTickets(Array.isArray(list?.tickets) ? list.tickets : []);
  }, [list?.tickets]);
  const GetDataTicket = useCallback(async (num) => {
      const response = await fetch(`${url}/lotery-bet/${num}`, {
        method: "get",
        headers: headers,
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(typeof data === "string" ? data : data?.message || "No se pudo consultar el ticket");
      }
      const ticket = ticketFromResponse(data);
      if (!ticket) throw new Error("El ticket no existe o no está disponible.");
      setTicketToPrin(ticket);
      setClassPrint("");
      return ticket;
  }, []);

  const previewTicket = async (num) => {
    setTicketStatus("Consultando ticket...");
    try {
      const ticket = await GetDataTicket(num);
      setTicketStatus(`Ticket ${ticket.num} listo para previsualizar.`);
    } catch (error) {
      setTicketStatus(error?.message || "No se pudo previsualizar el ticket.");
    }
  };

  const printTicket = async (num) => {
    setTicketStatus("Enviando al servidor de impresión...");
    try {
      const ticket = String(ticketToPrint?.num) === String(num)
        ? ticketToPrint
        : await GetDataTicket(num);
      const result = await ToPrinter(ticket);
      if (!result.printed) {
        throw new Error(result.detail || result.reason || "Servidor de impresión no disponible");
      }
      setTicketStatus(`Ticket ${ticket.num} enviado al servidor de impresión.`);
    } catch (error) {
      setTicketStatus(error?.message || "No se pudo imprimir el ticket.");
    }
  };

  const generatePDF = (tickets) => {
    const doc = new jsPDF("p", "pt", "letter");

    // Título del documento
    doc.setFontSize(18);
    doc.text("Reportes de Tickets", 40, 40);

    // Formatear los datos para la tabla
    const tableData = tickets.map((z, index) => [
      index + 1,
      z.num,
      new Date(z.date).toLocaleDateString("es-ES"),
      `${new Date(z.date).getHours().toString().padStart(2, "0")}:${new Date(
        z.date
      )
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${new Date(z.date)
          .getSeconds()
          .toString()
          .padStart(2, "0")}`,
      z.run,
      z.betted.toLocaleString("en-EN"),
      z.winner.state ? "Ganador" : "",
      z.winner.state
        ? parseInt(z.winner.amountWinner).toLocaleString("en-EN")
        : "",
      z.winner.factor,
      z.winner.jackpot.value > 0
        ? parseInt(z.winner.jackpot.value).toLocaleString("en-EN")
        : "",
      z.winner.state
        ? parseInt(z.winner.amountToPay).toLocaleString("en-EN")
        : "",
      z.winner.paid ? "Pagado" : "",
      z.winner.paid
        ? `${new Date(z.hourPaid)
          .getHours()
          .toString()
          .padStart(2, "0")}:${new Date(z.hourPaid)
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date(z.hourPaid)
              .getSeconds()
              .toString()
              .padStart(2, "0")}`
        : "",
    ]);

    // Configuración de autoTable
    doc.autoTable({
      startY: 60,
      head: [
        [
          "#",
          "Num",
          "Fecha",
          "Hora",
          "Carrera",
          "Apostado",
          "Ganador",
          "Monto Ganado",
          "Factor",
          "Jackpot",
          "Monto Pagado",
          "Estado",
          "Hora Pago.",
        ],
      ],
      body: tableData,
      margin: { top: 60 },
      theme: "grid", // Usar 'grid' para bordes alrededor de cada celda
      styles: {
        fontSize: 8,
        cellPadding: 3,
        lineColor: [0, 0, 0], // Color del borde
        lineWidth: 0.1, // Grosor del borde
        fillColor: [255, 255, 255], // Color de fondo (blanco, que es equivalente a sin relleno)
        textColor: [0, 0, 0], // Color del texto (negro)
      },
      headStyles: {
        fillColor: [255, 255, 255], // Sin relleno para el encabezado
        textColor: [0, 0, 0], // Color del texto en el encabezado
        lineWidth: 0.1, // Grosor del borde en el encabezado
        lineColor: [0, 0, 0], // Color del borde en el encabezado
      },
    });

    // Guardar el PDF
    doc.save("reporte-tickets.pdf");
  };
  return (
    <div className="noPrint">
      <button type="button" className="reina-btn reina-btn-primary" onClick={handleShow}>
        <EyeFill aria-hidden="true" /> Ver tickets
      </button>
      <Modal show={show} onHide={handleClose} size="xl" className="reina-modal">
        <Modal.Header closeButton>
          <Modal.Title>Reporte de tickets</Modal.Title>
        </Modal.Header>
        <form>
          <Modal.Body className="">
            <div className="col-12 row m-0 p-0">
              {tickets && tickets.length > 0 ? (
                <div className="col-12 noPrint">
                  <div className="reina-table-wrap">
                    <table className="table reina-table noPrint">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Num</th>
                          <th>Fecha</th>
                          <th>Hora</th>
                          <th>Carrera</th>
                          <th>Apostado</th>
                          <th>Ganador</th>
                          <th>Monto Ganado</th>
                          <th>Factor</th>
                          <th>Jackpot</th>
                          <th>Monto Pagado</th>
                          <th>Estado</th>
                          <th>Hora Pago.</th>
                          <th>Accion</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tickets.map((z) => (
                          <tr key={z.num}>
                            <td>{tickets.indexOf(z) + 1}</td>
                            <td>{z.num}</td>
                            <td>
                              {new Date(z.date).toLocaleDateString("es-ES")}
                            </td>
                            <td>{`${new Date(z.date)
                              .getHours()
                              .toString()
                              .padStart(2, "0")}:${new Date(z.date)
                              .getMinutes()
                              .toString()
                              .padStart(2, "0")}:${new Date(z.date)
                              .getSeconds()
                              .toString()
                              .padStart(2, "0")}`}</td>
                            <td>{z.run}</td>
                            <td>{z.betted.toLocaleString("en-EN")}</td>
                            <td>{z.winner.state ? "Ganador" : ""}</td>
                            <td>
                              {z.winner.state
                                ? parseInt(
                                    z.winner.amountWinner
                                  ).toLocaleString("en-EN")
                                : ""}
                            </td>
                            <td>{z.winner.factor}</td>
                            <td>
                              {z.winner.jackpot.value > 0
                                ? parseInt(
                                    z.winner.jackpot.value
                                  ).toLocaleString("en-EN")
                                : ""}
                            </td>
                            <td>
                              {z.winner.state
                                ? parseInt(z.winner.amountToPay).toLocaleString(
                                    "en-EN"
                                  )
                                : ""}
                            </td>
                            <td>{z.winner.paid ? "Pagado" : ""}</td>
                            <td>
                              {z.winner.paid
                                ? `${new Date(z.hourPaid)
                                    .getHours()
                                    .toString()
                                    .padStart(2, "0")}:${new Date(z.hourPaid)
                                    .getMinutes()
                                    .toString()
                                    .padStart(2, "0")}:${new Date(z.hourPaid)
                                    .getSeconds()
                                    .toString()
                                    .padStart(2, "0")}`
                                : ""}
                            </td>
                            <td>
                              <div className="reina-table-actions">
                                <button type="button" className="reina-btn reina-btn-muted reina-btn-icon" onClick={() => previewTicket(z.num)} aria-label={`Previsualizar ticket ${z.num}`} title="Previsualizar"><Eye /></button>
                                <button type="button" className="reina-btn reina-btn-gold reina-btn-icon" onClick={() => printTicket(z.num)} aria-label={`Imprimir ticket ${z.num}`} title="Imprimir"><Printer /></button>
                              </div>
                              
                              
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="reina-empty noPrint">No hay tickets en este período.</div>
              )}
              {ticketStatus && <div className="reina-status noPrint mt-3" role="status">{ticketStatus}</div>}
              {
                <div className={classPrint}>
                  <div>
                    <div className="p-0 m-0">
                      <div className="col-12 d-flex justify-content-center p-0 m-0">
                        <div className="divLogoPrint align-midle">
                          <img className="imgLogoPrint " src={imgLogo} alt="La Reina" />
                        </div>
                      </div>
                      <h6>{ticketToPrint ? ticketPointName(ticketToPrint) : ""}</h6>
                      <h6>
                        Ticket No.: {ticketToPrint ? ticketToPrint.num : ""}
                      </h6>
                      <h6>
                        Sorteo: {ticketToPrint ? ticketRunCode(ticketToPrint) : ""}
                      </h6>
                      <h6>
                        Fecha:{" "}
                        {ticketToPrint
                          ? `${new Date(ticketToPrint.date).toLocaleDateString(
                              "es-ES"
                            )} ${new Date(ticketToPrint.date)
                              .getHours()
                              .toString()
                              .padStart(2, "0")}:${new Date(ticketToPrint.date)
                              .getMinutes()
                              .toString()
                              .padStart(2, "0")}:${new Date(ticketToPrint.date)
                              .getSeconds()
                              .toString()
                              .padStart(2, "0")}`
                          : ""}
                      </h6>
                    </div>
                    <table className="table table-sm col-12 p-0 m-0 lh-1">
                      <thead>
                        <tr>
                          <th>Jugadas</th>
                          <th>Apostado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ticketToPrint
                          ? ticketToPrint.betted.map((z, index) => {
                              const line = lotteryTicketLine(z);
                              return (
                              <tr key={`${line.label}-${index}`} className="p-0 m-0">
                                <td className="p-0 m-0">{line.label}</td>
                                <td className="p-0 m-0">
                                  {line.amount.toLocaleString("en-EN", {
                                    maximumFractionDigits: 1,
                                  })}
                                </td>
                              </tr>
                              );
                            })
                          : ""}
                      </tbody>
                    </table>
                    <h3>
                      Total Apostado:{" "}
                      {ticketToPrint ? ticketToPrint.amount : ""}
                    </h3>
                    <div>
                      {" "}
                      <h3>Copia</h3>
                    </div>
                  </div>
                </div>
              }
            </div>
          </Modal.Body>
          <Modal.Footer className="noPrint">
            <button type="button" className="reina-btn reina-btn-muted" onClick={handleClose}>Cerrar</button>
            <button type="button" className="reina-btn reina-btn-primary" onClick={() => generatePDF(tickets)}>
              Descargar PDF
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}

export default Tickets;
